(function($){

	$(document).ready(function(){

		enquire.register('screen and (max-width: 991px)', {

			match: function() {

				$('.news-module__slider').each(function(index){
			
					if(!$(this).hasClass('slick-initialized')) {

						$(this).slick({
					        slidesToShow: 1,
					        slidesToScroll: 1,
					        arrows: false,
					        dots: true,
					        infinite: false,
					        autoplay: false,
					        swipe: true,
					        variableWidth: true,
					        mobileFirst: true,
					        prevArrow: '<button class="slick-prev"><svg width="16" height="27" viewBox="0 0 16 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5376 25.8475L14.1457 13.7085L1.5376 1.56936" stroke="black" stroke-width="2" stroke-linecap="round"/></svg></button>',
					        nextArrow: '<button class="slick-next"><svg width="16" height="27" viewBox="0 0 16 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5376 25.8475L14.1457 13.7085L1.5376 1.56936" stroke="black" stroke-width="2" stroke-linecap="round"/></svg></button>',

							responsive: [
								{
									breakpoint: 650,
									settings: {
										slidesToShow: 2,
					        			slidesToScroll: 1
									}
								},
								{
									breakpoint: 768,
									settings: {
										slidesToShow: 1,
					        			slidesToScroll: 1,
										arrows: true, 
										dots: true
									}
								},
								{
									breakpoint: 900,
									settings: {
										slidesToShow: 2,
					        			slidesToScroll: 1,
										arrows: true, 
										dots: true
									}
								},
							    {
							      breakpoint: 991,
							      settings: "unslick"
							    }
						  	]
					    });  
					}
				});
				
			}

		});

	});
	
})(jQuery);